{
  "version": 1,
  "asset_id": "417d9152-525a-4c9d-a408-116adcf43154",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/417d9152-525a-4c9d-a408-116adcf43154/bahcesehir-hizli-elektrikci-7-24-dukkan-6.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/417d9152-525a-4c9d-a408-116adcf43154/bahcesehir-hizli-elektrikci-7-24-dukkan-6.jpg",
  "original_filename": "bahcesehir-hizli-elektrikci-7-24-dukkan-6.jpg",
  "size": 509311,
  "content_type": "image/jpeg",
  "created_at": "2026-09-11T16:18:56Z"
}
